import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'ProcessWorkPermitReview';
root.props = {
	reviewData: Object,
	userData: Array,
	thisId: Number,
	callBack: Function,
};
root.data = {
  // 审核人的id
  empId: '',
	//当前操作数据
	cacheReviewData: {},
	//tab标签页
	thisTable: "1",
	//当前审核、回退数据
	thisReviewData: {},
	//显示审核回退内容输入界面
	showReviewModal: false,
	//当前审核模式，处于回退还是审核
  thisReviewModel: false,
  dialogVisible: false,
  dialogImageUrl: '',
  fileList: [], // 用于回显的照片
  fileList2: [], // 保存已上传的图片
}
root.mounted = function() {
  this.empId = localStorage.getItem('empId')
}
root.filters = {
  filter1(val) {
    return JSON.parse(val)
  }
}
root.methods = {
	getUserData: function(id){
		for(let item of this.userData){
			if(id === item.id){
				return item.name;
			}
		}
  },

  // 上传组件的东西
  handleRemove(file, fileList) {
    this.fileList = fileList
  },
  handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  },
  changeSuccess(file,fileList) {
    this.fileList = fileList
  },



	//开始审核
	startReview: function(row, model){
		this.thisReviewData = {...row};
		this.thisReviewModel = model;
		this.showReviewModal = true;
	},

	//取消审核
	cancelReview: function(){
		this.thisReviewData = {};
		this.showReviewModal = false;
	},

	clickOK: function(){
		this.reviewHttp();
  },

  // 回退审核
  backReview: function(row, model) {
    this.thisReviewData = {...row};
		this.thisReviewModel = model;
    this.reviewHttp()
  },

	//审核通过
	reviewHttp: function(){
		const data = {};
		data.orderNum = this.thisReviewData.orderNum;
		data.reviewOpinion = this.thisReviewData.reviewOpinion;
		data.reviewType = this.thisReviewModel?1:0;
		data.permitId = this.reviewData.id;
		let urlArr = []
		for(let i in this.fileList){
			urlArr.push({name: this.fileList[i].name, url: this.fileList[i].response.data})
		}
		data.signatureUrl = JSON.stringify(urlArr)
		const that = this;
		this.componentsMoudel.startPost('/workPermit/reviewPermit', data, true).then(res =>{
			that.showReviewModal = false;
			that.callBack(this.reviewData);
		});
	},


}
root.watch = {
	reviewData: function(newReviewData, oldReviewData){
    this.cacheReviewData = this.reviewData;
	console.log(this.cacheReviewData)
		if(this.cacheReviewData.reviewLogJson){
			this.cacheReviewData.reviewLogJson = JSON.parse(this.cacheReviewData.reviewLogJson);
		}
		if(this.cacheReviewData.reviewContentJson){
			this.cacheReviewData.reviewContentJson = JSON.parse(this.cacheReviewData.reviewContentJson);
		}
		if(this.cacheReviewData.businessJson){
			this.cacheReviewData.businessJson = JSON.parse(this.cacheReviewData.businessJson);
		}
		this.cacheReviewData.reviewContent = [];
		for(let item of this.cacheReviewData.reviewContentJson){
			if(item.reviewStatus===0){
        this.cacheReviewData.reviewContent.push(item);
				break;
			}
			if(item.reviewStatus===1){
				this.cacheReviewData.reviewContent.push(item);
			}
    }
    for(let i in this.cacheReviewData.reviewContent){
      if(this.cacheReviewData.reviewContent[i].signatureUrl){
        this.cacheReviewData.reviewContent[i].signatureUrl = JSON.parse(this.cacheReviewData.reviewContent[i].signatureUrl)
      }
    }
    // let len = this.cacheReviewData.reviewContent.length - 1
    // this.fileList = this.cacheReviewData.reviewContent[len].signatureUrl
    // for(let i in this.fileList){
    //   this.fileList[i].url = this.host + this.fileList[i].url
    // }
	},

}
FactoryComponents.initComponent(root);
